export const newDate = (input, timezone?: string): Date| null => {
  // const getMonth = {};
  // const getTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const reg = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/g;
  const reg2 = /([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))/g;
  const msReg1 = /(\d+):(\d+):(\d+).(\d+)/i;
  const msReg2 = /(\d+):(\d+):(\d+):(\d+)/i;
  const secReg = /(\d+):(\d+):(\d+)/i;
  // add regex for hours minutes seconds ms
  try {
    const matches = input.match(msReg1) || input.match(msReg2) || input.match(secReg);
    if (matches) {
      let AMPM, seconds;
      const  hours = matches[1], minutes = matches[2];
      if (matches[3]) {
        seconds = matches[3];
      }
      if (matches[4]) {
        AMPM = matches && matches[4] ? matches[4] : '';
      }
      // console.log(hours, ':', minutes, ':', seconds, AMPM);
    }
  } catch (e) {}
  if (reg.test(input)) {
    const match = input.match(reg) || input.match(reg2);
    // replace to /, supported by more browsers
    const dateString = match[0].replace(/-/g, '/');
    const dateArr = dateString.split('/');
    // time 00:00:00 is necessary
    const d = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
    // ensure time is 00:00:00.0
      d.setHours(0, 0, 0, 0);
      if (!timezone) {
        return d;
      } else {
        return new Date(d.toLocaleString('en-US', {timeZone: timezone}));
      }
  } else {
    try {
      return new Date(input);
    } catch (e) { return null; }
  }
};
class DateExtras {
  compareValue: number;
  today: Date;
  constructor() {}
  is() {
    return this;
  }
  between(num: number) {
    return this;
  }
  day() {
    return this;
  }
  days() {
    return this;
  }
  month() {
    return this;
  }
  months() {
    return this;
  }
  year() {
    return this;
  }
  years() {
    return this;
  }
  compare(date: string) {
    // 2 days of estimatedDeliveryDate
    let withinTwoDays: boolean;
    const estDeliveryDate = newDate(date);
    const today = new Date();
    // today.setHours(0, 0, 0, 0);
    estDeliveryDate.setDate(estDeliveryDate.getDate() + 2);
    withinTwoDays = estDeliveryDate.getTime() > today.getTime();
  }
}
